/*
 * NOTE:
 * ALL Paths must end with /
 * Group Paths controller wise
*/

var prefix = '/api';

var lpPrefix = '/lp/api';

//Auth
export const API_START_PARTNER = lpPrefix + '/lead-partner/start-lp/';
export const API_VALIDATE_PARTNER = lpPrefix + '/lead-partner/validate-otp/';
export const API_VALIDATE_PARTNEREMAIL = lpPrefix + '/lead-partner/validate-emailotp/';

export const API_LOGIN_LP = lpPrefix + '/lead/start-lp/';
export const API_LOGIN_LP_2In1 = lpPrefix + '/lead/start-lp2In1/';

export const API_MOBILE_DEVICEID = lpPrefix + '/lead/mobile-deviceid/';

export const API_LOGIN_LP_CRED = lpPrefix + '/lead/cred/';
export const API_LOGIN_LP_GPAY = lpPrefix + '/lead/gpay/';
export const API_LOGIN_LP_PHONEPE = lpPrefix + '/lead/phonepe/';


export const API_LP_CPL = lpPrefix + '/lead/cpl/';

export const API_LOGIN_ADMIN = lpPrefix + '/auth/login/';
export const API_REFRESH_ADMIN = lpPrefix + '/auth/refresh/';
export const API_CAPTCHA = lpPrefix + '/auth/captcha/';

export const API_LOGOUT_ADMIN = lpPrefix + '/admin/logout/';

export const API_LEADS_TEMPLATE = lpPrefix + '/admin/leads/download-template';

export const API_GETPARTNERCATEGORY = lpPrefix + '/lead-partner/get-PartnerCategory/';

// added by nitesh 01072023
export const API_GETSTATENAME = lpPrefix + '/lead-partner/getstatename/'; 
export const API_LPURLDATA = lpPrefix + '/lead-partner/LPUrlredirect/'; 
